"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .factory("Internal", [
    "$resource",
    "$stateParams",
    "apiSettings",
    function ($resource, $stateParams, apiSettings) {
      return $resource(
        null,
        { stateId: "@stateId" },
        {
          groups: {
            url: apiSettings.baseUri + "v1/internal/groups/list/ids",
            method: "GET",
            isArray: true,
          },
          parameters: {
            url: apiSettings.baseUri + "v1/internal/parameter",
            method: "GET",
            isArray: false,
            params: {
              entry: "",
            },
          },
          states: {
            url: apiSettings.baseUri + "v1/internal/states",
            method: "GET",
            isArray: true,
          },
          cities: {
            url: apiSettings.baseUri + "v1/internal/states/:stateId/cities",
            method: "GET",
            isArray: true,
          },
          segmentsList: {
            url: apiSettings.baseUri + "v1/internal/segments",
            method: "GET",
            isArray: true,
          },
          designersList: {
            url: apiSettings.baseUri + "v1/internal/designers",
            method: "GET",
            isArray: true,
          },
          colorsList: {
            url: apiSettings.baseUri + "v1/internal/colors/list",
            method: "GET",
            isArray: true,
            params: {
              pageSize: apiSettings.defaultPageSize,
              keyword: "",
            },
          },
          ownUsersList: {
            url: apiSettings.baseUri + "v1/internal/own/users/list",
            method: "GET",
            isArray: true,
            params: {
              pageSize: apiSettings.defaultPageSize,
              keyword: "",
            },
          },
          reproveReasonsList: {
            url: apiSettings.baseUri + "v1/internal/reprove-reasons",
            method: "GET",
            isArray: true,
          },
          colorsProductsList: {
            url: apiSettings.baseUri + "v1/internal/colors-products/list",
            method: "GET",
            isArray: true,
            params: {
              pageSize: apiSettings.defaultPageSize,
              keyword: "",
            },
          },
          othersProductsList: {
            url: apiSettings.baseUri + "v1/internal/others-products/list",
            method: "GET",
            isArray: true,
            params: {
              pageSize: apiSettings.defaultPageSize,
              keyword: "",
            },
          },
          approvers: {
            url: apiSettings.baseUri + "v1/internal/approvers",
            method: "GET",
            isArray: true,
          },
        }
      );
    },
  ]);
